<div
  class="popup"
  [class.is-open]="open()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="auth-title"
  [attr.aria-hidden]="!open()"
>
  <div class="popup__backdrop" (click)="popups.close()"></div>

  <div class="popup__dialog auth">
    <button type="button" class="popup__close" aria-label="Close sign in" (click)="popups.close()">&times;</button>

    <aside class="auth__aside">
      <span class="auth__eyebrow">Little Nap Account</span>
      <h2 class="auth__head">{{ copy().head }}</h2>
      <p class="auth__sub">{{ copy().sub }}</p>

      <!-- (a 14 s film: a man walks in from the right, turns, sits down in the recliner, leans back with the footrest up and falls asleep; then the chair is empty again) -->
      <svg class="scene" viewBox="28 -8 214 194" aria-hidden="true" focusable="false">
        <defs>
          <radialGradient id="scene-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0" stop-color="#fff" stop-opacity="0.28" />
            <stop offset="1" stop-color="#fff" stop-opacity="0" />
          </radialGradient>
          <linearGradient id="scene-leather" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#fffaf5" />
            <stop offset="1" stop-color="#f1d9cf" />
          </linearGradient>
          <linearGradient id="scene-knit" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stop-color="#5a141a" />
            <stop offset="1" stop-color="#3a0a0f" />
          </linearGradient>
        </defs>

        <ellipse class="scene__glow" cx="118" cy="112" rx="92" ry="80" />
        <ellipse class="scene__shadow" cx="124" cy="173" rx="72" ry="6" />

        <!-- chair: base, pedestal -->
        <rect class="scene__base" x="78" y="164" width="98" height="9" rx="4.5" />
        <rect class="scene__base" x="115" y="142" width="14" height="23" rx="2" />

        <!-- the back, with the man's body and head against it -->
        <g class="scene__back">
          <rect class="scene__chair" x="74" y="30" width="32" height="104" rx="16" />
          <rect class="scene__shade" x="74" y="30" width="32" height="104" rx="16" />
          <path class="scene__stitch" d="M85 60v58" />
          <rect class="scene__man scene__knit" x="95" y="50" width="29" height="78" rx="14.5" />
          <rect class="scene__man scene__neck" x="108" y="38" width="9" height="18" rx="3.5" />
          <g class="scene__man" transform="translate(113 30) scale(1.2) translate(-113 -40)">
            <circle class="scene__skin" cx="113" cy="40" r="11.5" />
            <circle class="scene__ear" cx="106.5" cy="42.5" r="2.7" />
            <path class="scene__nose" d="M123.5 38.5q3.2 3 .8 5.4-1.4.6-3.4.1Z" />
            <path class="scene__hair" d="M101.5 41c-1.5-11 6-18 14.5-17 6 .6 9.5 4.5 10 9-5-4.5-10-5-14-3.5-4 1.5-6.5 5.5-10.5 11.5Z" />
            <circle class="scene__cheek" cx="116.2" cy="45" r="2.5" />
            <path class="scene__brow" d="M116 36.2q3.2-1.9 6.4-.3" />
            <path class="scene__mouth" d="M115.8 47.6q2.1 1.4 4.1 0" />
          </g>
          <g class="scene__man" transform="translate(113 30) scale(1.2) translate(-113 -40)">
            <circle class="scene__eye-open" cx="119.5" cy="40.5" r="1.7" />
            <path class="scene__eye-shut" d="M116.8 40.4q2.6 2.6 5.2 0" />
          </g>
        </g>

        <!-- the man walking in: he is drawn behind the seat, so he sinks into it -->
        <g class="scene__walker">
          <g transform="scale(1.12)">
            <ellipse class="scene__shadow" cx="3" cy="1" rx="22" ry="3.5" />
            <g class="scene__leg scene__leg--back">
              <rect class="scene__pants" x="-6.5" y="-62" width="13" height="62" rx="6.5" />
              <rect class="scene__shoe" x="-6.5" y="-9" width="23" height="9" rx="4.5" />
              <rect class="scene__sole" x="-6.5" y="-3" width="23" height="3" rx="1.5" />
            </g>
            <g class="scene__leg scene__leg--front">
              <rect class="scene__pants" x="-6.5" y="-62" width="13" height="62" rx="6.5" />
              <rect class="scene__shoe" x="-6.5" y="-9" width="23" height="9" rx="4.5" />
              <rect class="scene__sole" x="-6.5" y="-3" width="23" height="3" rx="1.5" />
            </g>
            <g class="scene__bob">
              <g class="scene__swing scene__swing--back">
                <rect class="scene__arm" x="-5" y="-92" width="10" height="36" rx="5" />
                <circle class="scene__skin" cx="0" cy="-54" r="5" />
              </g>
              <rect class="scene__knit" x="-14" y="-96" width="28" height="42" rx="14" />
              <rect class="scene__neck" x="-1" y="-108" width="9" height="16" rx="3.5" />
              <g transform="translate(3.5 -113) scale(1.15) translate(-113 -40)">
                <circle class="scene__skin" cx="113" cy="40" r="11.5" />
                <circle class="scene__ear" cx="106.5" cy="42.5" r="2.7" />
                <path class="scene__nose" d="M123.5 38.5q3.2 3 .8 5.4-1.4.6-3.4.1Z" />
                <path class="scene__hair" d="M101.5 41c-1.5-11 6-18 14.5-17 6 .6 9.5 4.5 10 9-5-4.5-10-5-14-3.5-4 1.5-6.5 5.5-10.5 11.5Z" />
                <circle class="scene__cheek" cx="116.2" cy="45" r="2.5" />
                <path class="scene__brow" d="M116 36.2q3.2-1.9 6.4-.3" />
                <path class="scene__mouth" d="M115.8 47.6q2.1 1.4 4.1 0" />
                <circle class="scene__pupil" cx="119.5" cy="40.5" r="1.7" />
              </g>
              <g class="scene__swing scene__swing--front">
                <rect class="scene__arm" x="-5" y="-92" width="10" height="36" rx="5" />
                <circle class="scene__skin" cx="0" cy="-54" r="5" />
              </g>
            </g>
          </g>
        </g>

        <!-- the seat, his thigh, the armrest and the arm resting on it -->
        <rect class="scene__chair" x="78" y="120" width="96" height="28" rx="14" />
        <rect class="scene__shade" x="78" y="120" width="96" height="28" rx="14" />
        <rect class="scene__man scene__pants" x="98" y="110" width="70" height="20" rx="10" />
        <rect class="scene__chair" x="98" y="103" width="58" height="13" rx="6.5" />
        <rect class="scene__shade" x="98" y="103" width="58" height="13" rx="6.5" />
        <rect class="scene__man scene__arm" x="106" y="90" width="46" height="12" rx="6" />
        <circle class="scene__man scene__skin" cx="152" cy="96" r="5.5" />

        <!-- footrest, with his legs on it -->
        <g class="scene__foot">
          <rect class="scene__chair" x="150" y="121" width="15" height="46" rx="7.5" />
          <rect class="scene__man scene__pants" x="164" y="117" width="15" height="46" rx="7.5" />
          <rect class="scene__man scene__shoe" x="164" y="156" width="27" height="10" rx="5" />
          <rect class="scene__man scene__sole" x="164" y="163.5" width="27" height="3" rx="1.5" />
        </g>

        <text class="scene__z" x="50" y="16">z</text>
        <text class="scene__z scene__z--late" x="40" y="4">z</text>
      </svg>
    </aside>

    <div class="auth__main">
      <!-- (there is nothing to switch between once the visitor is in) -->
      <div class="tabs" role="tablist" aria-label="Sign in or sign up" [hidden]="view() === 'done'">
        <button
          type="button"
          class="tab"
          role="tab"
          [attr.aria-selected]="tab() === 'signin'"
          [attr.data-popup-focus]="tab() === 'signin' ? '' : null"
          (click)="setTab('signin')"
        >
          Sign In
        </button>
        <button
          type="button"
          class="tab"
          role="tab"
          [attr.aria-selected]="tab() === 'signup'"
          [attr.data-popup-focus]="tab() === 'signup' ? '' : null"
          (click)="setTab('signup')"
        >
          Sign Up
        </button>
      </div>

      <!-- the ways in, and the form -->
      <section class="view view--form" [hidden]="view() !== 'form'">
        <h3 class="auth__title" id="auth-title">{{ copy().title }}</h3>
        <p class="auth__lede">{{ copy().lede }}</p>

        <div class="field">
          <span class="field__label" id="auth-kind">Account type</span>
          <div class="kinds" role="radiogroup" aria-labelledby="auth-kind">
            @for (k of kinds; track k.id) {
              <button type="button" class="method" role="radio" [attr.aria-checked]="kind() === k.id" (click)="kind.set(k.id)">
                <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                  <path [attr.d]="k.icon" />
                </svg>
                {{ k.label }}
              </button>
            }
          </div>
        </div>

        <div class="social">
          <button type="button" class="sbtn sbtn--google" [attr.aria-busy]="busy() === 'Google'" (click)="social('Google')">
            <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
              <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
              <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
              <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z" />
              <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.42 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
            </svg>
            <span>{{ busy() === 'Google' ? 'Opening Google…' : copy().social + ' Google' }}</span>
          </button>

          <button type="button" class="sbtn sbtn--apple" [attr.aria-busy]="busy() === 'Apple'" (click)="social('Apple')">
            <svg width="16" height="19" viewBox="0 0 16 19" aria-hidden="true" focusable="false">
              <path fill="currentColor" d="M13.2 10.05c-.02-2.06 1.68-3.05 1.76-3.1-.96-1.4-2.45-1.6-2.98-1.62-1.27-.13-2.48.75-3.12.75-.64 0-1.63-.73-2.68-.71-1.38.02-2.65.8-3.36 2.04-1.43 2.48-.37 6.15 1.03 8.16.68.98 1.5 2.09 2.57 2.05 1.03-.04 1.42-.67 2.67-.67 1.25 0 1.6.67 2.69.65 1.11-.02 1.81-1 2.49-1.99.78-1.14 1.1-2.24 1.12-2.3-.02-.01-2.15-.83-2.19-3.26zM11.2 3.6c.56-.69.94-1.63.84-2.6-.81.04-1.8.54-2.38 1.22-.52.6-.98 1.57-.86 2.5.9.07 1.83-.46 2.4-1.12z" />
            </svg>
            <span>{{ busy() === 'Apple' ? 'Opening Apple…' : copy().social + ' Apple' }}</span>
          </button>
        </div>

        <div class="or">or</div>

        <div class="methods" role="tablist" aria-label="Sign up method">
          <button type="button" class="method" role="tab" [attr.aria-selected]="method() === 'phone'" (click)="setMethod('phone')">
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false">
              <rect x="4" y="1" width="8" height="14" rx="2" /><path d="M7 12.6h2" />
            </svg>
            Phone
          </button>
          <button type="button" class="method" role="tab" [attr.aria-selected]="method() === 'email'" (click)="setMethod('email')">
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false">
              <rect x="1" y="3" width="14" height="10" rx="2" /><path d="M1.6 4.2 8 8.8l6.4-4.6" />
            </svg>
            Email
          </button>
        </div>

        <!-- Sign Up only: who the account is for, whichever method is used -->
        <div [hidden]="tab() !== 'signup'">
          <div class="field field--name" [class.has-error]="errors().name">
            <label for="auth-name">Full name</label>
            <input #name type="text" id="auth-name" name="auth_name" autocomplete="name" placeholder="Your name" (input)="clearError('name')" (keydown.enter)="$event.preventDefault(); submit()" />
            <p class="err" role="alert">{{ errors().name }}</p>
          </div>

          <div class="field field--business" [class.has-error]="errors().business" [hidden]="kind() === 'online'">
            <label for="auth-business">{{ kind() === 'wholesaler' ? 'Firm / company name' : 'Shop name' }}</label>
            <input #business type="text" id="auth-business" name="auth_business" autocomplete="organization" [attr.placeholder]="kind() === 'wholesaler' ? 'Your firm name' : 'Your shop name'" (input)="clearError('business')" (keydown.enter)="$event.preventDefault(); submit()" />
            <p class="err" role="alert">{{ errors().business }}</p>
          </div>
        </div>

        <!-- by phone -->
        <div [hidden]="method() !== 'phone'">
          <div class="field field--phone" [class.has-error]="errors().phone">
            <label for="auth-phone">Mobile number</label>
            <div class="phone">
              <select #code aria-label="Country code" (change)="onPhoneInput()">
                <option value="+91" selected>&#127470;&#127475; +91</option>
                <option value="+971">&#127462;&#127466; +971</option>
                <option value="+1">&#127482;&#127480; +1</option>
                <option value="+44">&#127468;&#127463; +44</option>
                <option value="+61">&#127462;&#127482; +61</option>
              </select>
              <input
                #phone
                type="tel"
                id="auth-phone"
                name="auth_phone"
                inputmode="numeric"
                autocomplete="tel-national"
                placeholder="98765 43210"
                maxlength="15"
                (input)="onPhoneInput()"
                (keydown.enter)="$event.preventDefault(); submit()"
              />
            </div>
            <p class="err" role="alert">{{ errors().phone }}</p>
          </div>
        </div>

        <!-- by email -->
        <div [hidden]="method() !== 'email'">
          <div class="field field--email" [class.has-error]="errors().email">
            <label for="auth-email">Email address</label>
            <input #email type="email" id="auth-email" name="auth_email" autocomplete="email" placeholder="you@example.com" (keydown.enter)="$event.preventDefault(); submit()" />
            <p class="err" role="alert">{{ errors().email }}</p>
          </div>

          <div class="field field--password" [class.has-error]="errors().password">
            <label for="auth-password">Password</label>
            <div class="pw">
              <input
                #password
                [type]="passwordShown() ? 'text' : 'password'"
                id="auth-password"
                name="auth_password"
                [attr.autocomplete]="tab() === 'signup' ? 'new-password' : 'current-password'"
                [attr.placeholder]="tab() === 'signup' ? 'Minimum 8 characters' : 'Your password'"
                (input)="onPasswordInput()"
                (keydown.enter)="$event.preventDefault(); submit()"
              />
              <button
                type="button"
                class="pw__eye"
                [attr.aria-label]="passwordShown() ? 'Hide password' : 'Show password'"
                [attr.aria-pressed]="passwordShown()"
                (click)="passwordShown.set(!passwordShown())"
              >
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false">
                  <path d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10z" /><circle cx="10" cy="10" r="2.6" />
                </svg>
              </button>
            </div>
            <div class="strength" [attr.data-score]="score()" [hidden]="tab() !== 'signup'">
              <span class="strength__bars"><i></i><i></i><i></i><i></i></span>
              <span class="strength__label" aria-live="polite">{{ scoreLabel() }}</span>
            </div>
            <p class="err" role="alert">{{ errors().password }}</p>
          </div>

          <div class="field field--confirm" [class.has-error]="errors().confirm" [hidden]="tab() !== 'signup'">
            <label for="auth-confirm">Confirm password</label>
            <input #confirm [type]="passwordShown() ? 'text' : 'password'" id="auth-confirm" name="auth_confirm" autocomplete="new-password" placeholder="Re-enter your password" (input)="clearError('confirm')" (keydown.enter)="$event.preventDefault(); submit()" />
            <p class="err" role="alert">{{ errors().confirm }}</p>
          </div>

          <p class="auth__lede auth__pw-hint" [hidden]="tab() !== 'signup'">At least 8 characters, with a letter and a number.</p>
          <button type="button" class="forgot" [hidden]="tab() !== 'signin'" (click)="useOtp()">Forgot password? Use OTP instead</button>
        </div>

        <!-- signing up, by phone or by email, needs the same agreement -->
        <label class="consent" [class.has-error]="consentMissing()" for="auth-consent" [hidden]="tab() !== 'signup'">
          <input #consent type="checkbox" id="auth-consent" (change)="consentMissing.set(false)" />
          <span>
            I agree to the <a [href]="termsHref" target="_blank" rel="noopener">Terms</a> and
            <a [href]="privacyHref" target="_blank" rel="noopener">Privacy Policy</a>, and to receiving order updates on
            WhatsApp and SMS.
          </span>
        </label>

        <button type="button" class="submit" [attr.aria-busy]="busy() === 'submit'" (click)="submit()">{{ submitLabel() }}</button>

        <p class="alt">
          {{ copy().altText }}
          <button type="button" (click)="setTab(tab() === 'signup' ? 'signin' : 'signup')">{{ copy().altBtn }}</button>
        </p>
      </section>

      <!-- the one-time code -->
      <section class="view view--otp" [hidden]="view() !== 'otp'">
        <button type="button" class="back" (click)="backToForm(false)">&larr; Back</button>
        <h3 class="auth__title">Enter the 6-digit code</h3>
        <p class="sent">
          Sent to <strong>{{ sentTo() }}</strong
          >. <button type="button" (click)="backToForm(true)">Change number</button>
        </p>

        <!-- (goes away with DEMO, when a real service sends the code) -->
        <p class="hint">
          Demo build: no SMS is sent. Use <code>{{ demoOtp }}</code> to continue.
        </p>

        <div class="otp" [class.has-error]="otpError()">
          @for (i of otpBoxes; track i) {
            <input
              #otp
              type="text"
              inputmode="numeric"
              maxlength="1"
              [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
              [attr.aria-label]="'Digit ' + (i + 1)"
              (input)="onOtpInput(i)"
              (keydown)="onOtpKey($event, i)"
              (paste)="onOtpPaste($event)"
            />
          }
        </div>
        <p class="err err--otp" role="alert">{{ otpError() }}</p>

        <div class="resend">
          <span>{{ resendIn() > 0 ? 'Resend available in ' + resendIn() + 's' : 'Didn’t get the code?' }}</span>
          <button type="button" [disabled]="resendIn() > 0" (click)="resend()">Resend OTP</button>
        </div>

        <button type="button" class="submit" [attr.aria-busy]="busy() === 'verify'" (click)="verifyOtp()">
          {{ busy() === 'verify' ? 'Verifying…' : 'Verify & Continue' }}
        </button>
      </section>

      <!-- in -->
      <section class="view view--done" [hidden]="view() !== 'done'">
        <span class="done__tick" aria-hidden="true">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#1a8f4a" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
        </span>
        <h3>{{ done().title }}</h3>
        <p>
          {{ done().before }}<strong>{{ done().label }}</strong
          >{{ done().after }}
        </p>
        <button type="button" class="submit" (click)="popups.close()">Start shopping</button>
      </section>
    </div>
  </div>
</div>
